import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RestrictedDevice from '../../pages/restricted-device/restricted-device';
import ApiHealthTest from '../../pages/api-health-test/api-health-test';
import LoginForm from '../../pages/login/login';

function OpenRoutes() {
  return (
    <Routes>
      <Route path="/*" element={<LoginForm />} />
      <Route path="/login" element={<LoginForm />} />
      <Route path="/client/:slug/*" element={<LoginForm />} />
      <Route path="/restricted" element={<RestrictedDevice />} />
      <Route path="/api-test" element={<ApiHealthTest />} />
    </Routes>
  );
}

export default OpenRoutes;
